import { asJsonArray } from './shipChanges.js';
import { predictedEta, toDayMs } from './shipmentSchedule.js';
import { getShipmentCommodityWeight } from './groupByVarietyType.js';

/** Cargo still to arrive on a card, per stop: undelivered heads (endpoint decides), else the stop,
 *  else the card itself. Legacy units (no heads) of an arrived card are dropped. */
export const arrivalUnits = (card) => {
  const arrived = String(card.status || '').toLowerCase() === 'arrived';
  const stops = asJsonArray(card.voyage_stops);
  if (!stops.length) return arrived ? [] : [card];
  return stops.flatMap((st) => {
    if (Array.isArray(st?.heads)) return st.heads.filter((h) => !h.delivered);
    return arrived || !st ? [] : [st];
  });
};

export const unitEta = (u) => ('arriving_eta' in u ? u.arriving_eta : predictedEta(u));

const carries = (u, commodity) => String(u.commodities || '')
  .split(',')
  .some((c) => c.trim().toLowerCase() === String(commodity).trim().toLowerCase());

/** [{ card, units }] for cards with at least one unit whose own ETA falls inside the window
 *  and (heads only, when a commodity is selected) that carries the commodity. */
export const filterByDays = (list, days, now = new Date(), commodity = '') => {
  // Calendar-day window: date-only ETAs must not expire at UTC midnight.
  const t = new Date(toDayMs(now));
  const todayMs = t.getTime();
  const cutoff = new Date(t.getFullYear(), t.getMonth(), t.getDate() + days).getTime();
  return list.flatMap((card) => {
    const units = arrivalUnits(card).filter((u) => {
      if (commodity && u !== card && !carries(u, commodity)) return false;
      const raw = unitEta(u);
      if (!raw) return false;
      const eta = toDayMs(raw);
      return eta != null && eta >= todayMs && eta <= cutoff;
    });
    return units.length ? [{ card, units }] : [];
  });
};

export const windowWeight = (entries, commodity) =>
  entries.reduce(
    (sum, { units }) => sum + units.reduce(
      (s, u) => s + (getShipmentCommodityWeight(u, commodity) ?? 0),
      0,
    ),
    0,
  );

/** Sidebar rows: one per in-window unit, carrying the card identity and that unit's ETA. */
export const windowRows = (entries) =>
  entries.flatMap(({ card, units }) => units.map((u) => ({
    ...card,
    ...u,
    container_number: card.container_number,
    vessel: card.vessel,
    current_vessel: card.current_vessel,
    booking_vessel: card.booking_vessel,
    estimated_arrival: unitEta(u),
  })));
